import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'

import { BRAND_CONFIG } from '@@brand'
import { useModalStore } from '@features/modal'


import { URL_CART } from '@shared/contants'
import { CONTACTS } from '@shared/contants/contacts'
import Button from '@shared/ui/button'
import Container from '@shared/ui/container'
import Space from '@shared/ui/space'

import SupportModal from './SupportModal'

import styles from './styles.module.scss'

export default function MinimalHeader () {
  const { t } = useTranslation('common')
  const isTablet = useMediaQuery('(max-width: 1180px)')
  const { openModal } = useModalStore()

  return (
    <header className={styles.minimal}>
      <Container>
        <Space className={styles.minimal__inner}>
          <Button
            className={styles.minimal__button}
            to={URL_CART}
            size={isTablet ? 'medium' : 'large'}
            theme="grey"
          >
            <ReactSVG
              className={styles.minimal__icon}
              src="/icons/arrow-left.svg"
            />
            {!isTablet && t('back_to_cart')}
          </Button>
          <img
            src={BRAND_CONFIG.images.logo}
            style={{ height: isTablet ? 40 : 50 }}
          />
          {!isTablet ? (
            <div className={styles.minimal__text}>
              <a href={`tel:${CONTACTS.phone}`}>{CONTACTS.phone}</a>
              <span>{t('support')}</span>
            </div>
          ) : (
            <Button
              onClick={() => {
                openModal('support', <SupportModal />, {
                  title: t('support_service'),
                })
              }}
              className={styles.minimal__calling}
              theme="white"
            >
              <ReactSVG src="/icons/phone-calling.svg" />
            </Button>
          )}
        </Space>
      </Container>
    </header>
  )
}
